import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { useLocation, useNavigate } from 'react-router-dom';
import { userRoles } from 'utils/currentUserRoles';
import { useGetAffiliateOptions } from 'hooks';
import { AuthContext } from 'authentication/AuthContext';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useDispatch } from 'react-redux';
import dispatchingApi, { tagTypes } from '../../dispatchingApi';

const AffiliateDropdown = ({ onChange }) => {
  const affiliatesOptions = useGetAffiliateOptions([userRoles.CARRIER]);
  const { affiliates, currentAffiliate, setCurrentSelectedAffiliate } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const getAffiliateIndex = (affiliateId, affiliateCompanyId) =>
    affiliates.findIndex(
      ({ customerIdName, dataCompanyId }) =>
        affiliateId === customerIdName && parseInt(affiliateCompanyId) === dataCompanyId
    );

  const handleOnChange = ({ target: { value } }) => {
    const [affiliateId, affiliateCompanyId] = value.split('-');
    const affiliateIndex = getAffiliateIndex(affiliateId, affiliateCompanyId);
    setCurrentSelectedAffiliate(affiliateIndex);
    onChange(value);
    const newUrl = R.compose(
      R.join('/'),
      R.update(3, affiliateCompanyId),
      R.update(2, affiliateId),
      R.split('/'),
      R.prop('pathname')
    );
    navigate(newUrl(location), { replace: true });
    dispatch(dispatchingApi.util.invalidateTags(tagTypes));
  };

  const getAffiliateValue = affiliate => {
    if (affiliate) {
      if (affiliate.carrier) {
        return `${affiliate.customerIdName}-${affiliate.dataCompanyId}`;
      }
    }
    return '';
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="affiliate-label">Affiliate</InputLabel>
      <Select
        fullWidth
        label="Affiliate"
        labelId="affiliate-label"
        onChange={handleOnChange}
        value={getAffiliateValue(currentAffiliate)}
      >
        {affiliatesOptions.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

AffiliateDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default AffiliateDropdown;
